module.exports = __webpack_public_path__ + "8822f182865946f8ece287fd5d05e315.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/misc/halloween-sale-banner.png
// module id = 307
// module chunks = 0